import { useEffect } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Marquee } from "@/components/Marquee";
import { Grain } from "@/components/Grain";
import { Hero } from "@/sections/home/Hero";
import { Services } from "@/sections/home/Services";
import { About } from "@/sections/home/About";
import { Manifesto } from "@/sections/home/Manifesto";
import { Contact } from "@/sections/home/Contact";
import { OtherProjects } from "@/sections/home/OtherProjects";

export default function Home() {
  const { t } = useLanguage();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-ink min-h-screen" data-testid="home-page">
      <Grain />
      <Navbar
        theme="dark"
        links={[
          { label: t.home.nav.services, href: "#services" },
          { label: t.home.nav.about, href: "#about" },
          { label: t.home.nav.contact, href: "#contact" },
        ]}
        ctaLabel={t.home.nav.cta}
        ctaHref="#contact"
        logoSuffix="TRANSCENDENTAL"
        logoTo="/"
      />
      <Hero />
      <Marquee text={t.home.marquee} theme="dark" />
      <Services />
      <About />
      <Manifesto />
      <Contact />
      <OtherProjects />
      <Footer theme="dark" tagline={t.home.footer.tagline} rights={t.home.footer.rights} location={t.home.footer.location} />
    </div>
  );
}
